<div class="task-reminder-container">
  <!-- Title and buttons on same line -->
  <div class="task-reminder-content">
    <!-- Title -->
    <h3>Rappel / tâche</h3>

    <!-- Service buttons row -->
    <div class="service-buttons-row">
      <!-- Individual service buttons using ex-button -->
      @for (service of services; track service.id) {
        @if (shouldShowService(service)) {
          <ex-button
            [size]="'small'"
            [type]="'secondary'"
            [variant]="'ghost'"
            [iconSrc]="service.iconPath"
            [disabled]="!service.enabled"
            [ngbTooltip]="service.tooltip | translate"
            #tooltip="ngbTooltip"
            placement="bottom auto"
            tooltipClass="simple-tooltip fit"
            container="body"
            [openDelay]="500"
            (click)="onServiceClick(service, tooltip)"
            class="service-button"
          >
          </ex-button>
        }
      }
    </div>
  </div>
</div>
